import { queryOptions } from '@tanstack/react-query';
import { Domain } from '@repo/domain';
import { resolveRepository } from '../registry/resolveRepository';
export const reservationSpanPaymentLinkKeys = {
    all: ['reservationSpanPaymentLinks'],
    get: (filter) => ['reservationSpanPaymentLinks', 'get', filter],
};
export const reservationSpanPaymentLinkOptions = {
    get: (filter) => queryOptions({
        queryKey: reservationSpanPaymentLinkKeys.get(filter),
        queryFn: async () => {
            const repository = await resolveRepository(Domain.ReservationSpanPaymentLink);
            return repository.get(filter);
        },
    }),
    pay: () => ({
        mutationFn: async (request) => {
            const repository = await resolveRepository(Domain.ReservationSpanPaymentLink);
            return repository.pay(request);
        },
    }),
};
